define(['app/controllers/Controller', 'rv!app/views/adminBar'], function (
    Controller,
    adminBarTemplate
) {
    function AdminController(admin) {
        if (!admin) return false;

        var ractiveAdmin = false;
        var Ractive = false;
        var anchor = false;

        function init() {
            Ractive = Controller.ractive;

            anchor = $('<span>');
            $('body').prepend(anchor);

            ractiveAdmin = new Ractive({
                el: anchor,
                template: adminBarTemplate,
                data: admin.data,
                magic: true,
            });

            window.admin = admin;

            ractiveAdmin.on('toggle', function () {
                admin.data.active = !admin.data.active;
            });

            ractiveAdmin.on('emptyCache', function () {
                var go = confirm(
                    'Säker på att du vill tömma cachen? Din varukorg kommer gå förlorad.'
                );

                if (go) {
                    localStorage.clear();
                    window.location = window.location.href;
                }
            });

            $(function () {
                $('body').addClass('office');
            });
        }

        init();
    }

    return AdminController;
});
